import Vue from 'vue'
import Meta from 'vue-meta'

import VueYandexMetrika from 'vue-yandex-metrika'
import VueAnalytics from 'vue-analytics'

import './plugins/vuetify'
import './plugins/vue-lazyload'
import './plugins/vue-awesome-swiper'
// import '@fortawesome/fontawesome-free/css/all.css'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'

import { faListAlt  } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import { faCogs } from '@fortawesome/free-solid-svg-icons'
import { faShippingFast } from '@fortawesome/free-solid-svg-icons'
import { faUserCheck } from '@fortawesome/free-solid-svg-icons'
import { faTools } from '@fortawesome/free-solid-svg-icons'
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faWhatsapp, faListAlt, faAngleRight, faAngleLeft, faInstagram, faPencilAlt, faCheck, faShieldAlt, faCogs, faShippingFast, faUserCheck, faTools, faHandHoldingUsd, faBars)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(Meta)

Vue.use(VueYandexMetrika, {
  id: 38719760,
  router: router,
  env: process.env.NODE_ENV
  // other options
})

Vue.use(VueAnalytics, {
  id: 'UA-81348887-1'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
